export const UNIT_ASSIGNMENT_MODALS = {
	edit: 'EDIT_UNIT_MODAL',
	unassign: 'UNASSIGN_UNIT_MODAL',
	editArrived: 'EDIT_UNIT_ARRIVED_MODAL',
	unassignArrived: 'UNASSIGN_UNIT_ARRIVED_MODAL'
};

export default { UNIT_ASSIGNMENT_MODALS };
